<div class="flex-col h100">
  <div class="flex-row gap-4">
    @if (label()) {
      <mat-label class="select-label">{{ label() }}</mat-label>
    }
    <vl-chips
      [matMenuTriggerFor]="selectMenu"
      [iconLeft]="iconLeft()"
      iconRight="expand_more"
      [state]="buttonState()"
      (action)="menuTrigger.openMenu(); onOpenMenu()"
      #menuTrigger="matMenuTrigger">
      @if (selectedElement()?.name) {
        {{ selectedElement().name }}
      } @else if (customLabel()) {
        {{ customLabel() }}
      } @else if (!disableLabel()) {
        {{ 'form.select' | trans }}
      }
    </vl-chips>
    <mat-menu #selectMenu="matMenu" (closed)="onCloseMenu()">
      @for (element of elements(); track $index) {
        <button mat-menu-item (click)="selectElement(element)" [matTooltip]="element.tooltip"
                [matTooltipShowDelay]="0"
                matTooltipPosition="right">
          {{ element.name }}
        </button>
      }
    </mat-menu>
  </div>
</div>
